var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLinkExtraSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 14,
  fill: "none",
  viewBox: "0 0 13 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#2A836B",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.9 2.5v1h2.4L5.8 9l.7.7L12 4.2v2.5h1V2.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 1.5h7v-1H0v13h12v-1H1z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h13v13H0z"
})))));
export default SvgExternalLinkExtraSmall;